import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import { createChangeScaleIndexAction, createSelectComponentAction, createUnselectComponentAction, createUnselectPointAction, createUpdateComponentsAction, createUpdateLinksAction } from "../actions";
import { createGetSelectedComponents, getComponents, getLinks, getRequestedScrollPosition, getScaleIndex, getSelectedLinksIndexes, getSelectedPoint } from "../selectors";
import { EmptyObjectType, IPicassoState, ObjectType, PicassoEditorProps, WrapMapStateToProps } from "../types";
import { PicassoPaintingComponent, PicassoPaintingComponentProps } from "./PicassoPaintingComponent";

type StateProps = Pick<PicassoPaintingComponentProps, "components" | "links" | "selectedComponents" | "selectedLinksIndexes" | "selectedPoint" | "scaleIndex" | "requestedScrollPosition">;

/**
 * Vytvoří createMapStateToProps, pro které obalí mapStateToProps zadanou obalovací funkcí.
 * @param wrapMapStateToProps Funkce pro obalení mapStateToProps.
 */
const wrapCreateMapStateToProps = <S extends ObjectType>(wrapMapStateToProps: WrapMapStateToProps<S>) => () => {
    const getSelectedComponents = createGetSelectedComponents();

    const mapStateToProps: MapStateToProps<StateProps, EmptyObjectType, IPicassoState> = (state) => ({
        components: getComponents(state),
        links: getLinks(state),
        selectedComponents: getSelectedComponents(state),
        selectedLinksIndexes: getSelectedLinksIndexes(state),
        selectedPoint: getSelectedPoint(state),
        scaleIndex: getScaleIndex(state),
        requestedScrollPosition: getRequestedScrollPosition(state),
    });

    return wrapMapStateToProps(mapStateToProps);
};

type DispatchProps = Pick<PicassoPaintingComponentProps, "selectComponent" | "unselectComponent" | "updateComponents" | "updateLinks" | "changeScaleIndex" | "unselectPoint">;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, PicassoEditorProps> = (dispatch, { picassoInstanceKey }) => ({
    selectComponent: (component, reselect) => dispatch(createSelectComponentAction(picassoInstanceKey, component, reselect)),
    unselectComponent: (componentIndex) => dispatch(createUnselectComponentAction(picassoInstanceKey, componentIndex)),
    updateComponents: (changedComps) => dispatch(createUpdateComponentsAction(picassoInstanceKey, changedComps)),
    updateLinks: (changedLinks) => dispatch(createUpdateLinksAction(picassoInstanceKey, changedLinks)),
    changeScaleIndex: (newScaleIndex) => dispatch(createChangeScaleIndexAction(picassoInstanceKey, newScaleIndex)),
    unselectPoint: () => dispatch(createUnselectPointAction(picassoInstanceKey)),
});

export const createPicassoPainting = <S extends ObjectType>(wrapMapStateToProps: WrapMapStateToProps<S>) => connect(wrapCreateMapStateToProps(wrapMapStateToProps), mapDispatchToProps)(PicassoPaintingComponent);
